<template>
    <div>
        <h1>Pflege View</h1>
    </div>

    <div>
        <iframe class="pflegerechnerframe" src="https://www.vigopflegerechner.de" frameborder="0"></iframe>
    </div>


</template>

<script setup>

</script>

<style scoped>
    .pflegerechnerframe {
        min-width: 990px;
        height: clamp(750px, 80svh, 1024px);
    }
</style>